import { addDays, subDays, subWeeks } from 'date-fns'
import { create } from 'zustand'

import { ExtendedFiltersEntries } from '@/components/HistoricalStatistics/drawer/FiltersDrawer'

import {
  Filters,
  FiltersEntries,
  FiltersEntriesKey,
  HistoricalStatisticsStoreConfig,
  HistoricalStatisticsStoreState
} from './historicalStatistics.store.types'
import { filtersToQueryParams } from './utils'

const twoDaysAgo = subDays(new Date(), 2)
const weekBefore = addDays(subWeeks(twoDaysAgo, 1), 1)

export const initialFilters: Filters = {
  period: {
    fromDate: weekBefore,
    toDate: twoDaysAgo
  },
  country: [],
  content: {
    sport: null,
    property: null,
    tournament: null
  },
  operators: [],
  usSubdivision: [],
  caSubdivision: [],
  cdn: null,
  userAgent: null,
  platform: null
}

export const initialFiltersEntries: ExtendedFiltersEntries = {
  main: initialFilters,
  h2h: initialFilters,
  isH2H: false
}

const initialState = {
  isH2H: false,
  drawerPosition: 'right',
  filtersEntries: initialFiltersEntries,
  queryParams: {
    main: filtersToQueryParams(initialFiltersEntries.main),
    h2h: filtersToQueryParams(initialFiltersEntries.h2h)
  }
} as HistoricalStatisticsStoreState

export const useHistoricalStatisticsStore = create<HistoricalStatisticsStoreConfig>((set) => ({
  ...initialState,

  setFiltersEntries: (filtersEntries) => {
    set((state) => ({
      ...state,
      filtersEntries: {
        ...state.filtersEntries,
        ...Object.entries(filtersEntries).reduce((acc, [id, filters]) => {
          const key = id as FiltersEntriesKey

          acc[key] = {
            ...state.filtersEntries[key],
            ...filters
          }

          return acc
        }, {} as FiltersEntries)
      }
    }))
    set((state) => ({
      ...state,
      queryParams: {
        main: filtersToQueryParams(state.filtersEntries.main),
        h2h: filtersToQueryParams(state.filtersEntries.h2h)
      }
    }))
  },

  setIsH2H: (isH2H) => set(() => ({ isH2H })),
  setDrawerPosition: (drawerPosition) => set(() => ({ drawerPosition })),
  resetState: () => set(() => initialState)
}))
